module.exports = __webpack_public_path__ + "img/nuki-box-sm.da333ab1.svg";